import styled from 'styled-components'
import { DEVICES } from 'theme/devicesSizes'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  min-height: 100vh;
  background-color: #fff;

  @media ${DEVICES.tablet} {
    min-height: auto;
    justify-content: center;
    align-items: flex-start;
    padding-bottom: 40px;
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center; 
  align-items: center;
  width: 50%;
    
    @media ${DEVICES.tablet} {
      width: 80%;
      margin-top: 10%; 
      justify-content: flex-start;
  }
`
